export default __webpack_public_path__ + "static/caption-03-chs-bb267ff170d45adccc8ea1a8cdb06f28.png";